import type { Mode, Topic } from './topics';

/** 스프레드(배열법) 정의. 새 스프레드는 여기에만 추가하면 UI·프롬프트·검증이 따라온다 */
export interface SpreadPosition {
  index: number;
  nameKo: string;
  meaning: string;
}

export interface Spread {
  id: string;
  nameKo: string;
  positions: SpreadPosition[];
  /** 프리미엄 전용 (결제/구독 도입 시 게이트) */
  premium?: boolean;
}

export const SPREADS = {
  'one-card': {
    id: 'one-card',
    nameKo: '원 카드',
    positions: [
      { index: 0, nameKo: '오늘의 메시지', meaning: '오늘 하루를 관통하는 핵심 메시지와 조언' },
    ],
  },
  'three-card': {
    id: 'three-card',
    nameKo: '3장 스프레드 (과거·현재·미래)',
    positions: [
      { index: 0, nameKo: '과거', meaning: '이 문제의 뿌리, 지금까지의 흐름' },
      { index: 1, nameKo: '현재', meaning: '지금 놓인 상황과 마음' },
      { index: 2, nameKo: '미래', meaning: '앞으로 향하는 방향과 조언' },
    ],
  },
  'relationship-5': {
    id: 'relationship-5',
    nameKo: '관계 스프레드 (5장)',
    positions: [
      { index: 0, nameKo: '나의 마음', meaning: '내가 이 관계에서 느끼는 진짜 마음' },
      { index: 1, nameKo: '상대의 마음', meaning: '상대가 이 관계를 바라보는 시선' },
      { index: 2, nameKo: '관계의 현재', meaning: '두 사람 사이의 지금 에너지' },
      { index: 3, nameKo: '넘어야 할 것', meaning: '관계가 나아가기 위해 풀어야 할 과제' },
      { index: 4, nameKo: '나아갈 방향', meaning: '이 관계가 향할 수 있는 가장 좋은 방향' },
    ],
  },
  'celtic-cross': {
    id: 'celtic-cross',
    nameKo: '켈틱 크로스 (10장)',
    premium: true,
    positions: [
      { index: 0, nameKo: '현재 상황', meaning: '질문의 중심에 있는 현재의 에너지' },
      { index: 1, nameKo: '장애물', meaning: '가로막고 있거나 교차하는 힘' },
      { index: 2, nameKo: '무의식', meaning: '상황의 뿌리, 스스로 모르는 바탕' },
      { index: 3, nameKo: '과거', meaning: '지나가고 있는 영향' },
      { index: 4, nameKo: '의식·목표', meaning: '의식적으로 바라는 것' },
      { index: 5, nameKo: '가까운 미래', meaning: '곧 다가올 흐름' },
      { index: 6, nameKo: '나 자신', meaning: '이 상황 속의 나의 태도' },
      { index: 7, nameKo: '주변 환경', meaning: '주변 사람들과 환경의 영향' },
      { index: 8, nameKo: '희망과 두려움', meaning: '마음 깊은 곳의 기대와 불안' },
      { index: 9, nameKo: '최종 결과', meaning: '이 흐름이 향하는 종착점' },
    ],
  },
} as const satisfies Record<string, Spread>;

export type SpreadId = keyof typeof SPREADS;
export const DEFAULT_SPREAD: SpreadId = 'three-card';

/**
 * 모드·주제별 기본 스프레드 (doc/ux-card-picking.md 로드맵)
 * - 오늘의 운세 → 원 카드 (가볍고 빠르게)
 * - 커플 → 관계 스프레드
 * - 그 외 → 3장 (켈틱 크로스는 프리미엄 도입 시 선택지로)
 */
export function getDefaultSpread(mode: Mode, topic: Topic): SpreadId {
  if (mode === 'couple') return 'relationship-5';
  if (topic === 'today') return 'one-card';
  return DEFAULT_SPREAD;
}
